import {
  IconDashboard,
  IconDeviceAnalytics,
  IconMessages,
} from '@tabler/icons';
// import { campaignStatuses } from 'constants/statuses';

const icons = { IconDashboard, IconDeviceAnalytics, IconMessages };

const campaigns = (campaignItems) => {
  // TODO: fix filtering
  const pendingCampaigns = [
    ...campaignItems
      // .filter((el) => el.status === campaignStatuses.CAMPAIGN_CREATED)
      .map(({ id, name }) => {
        return {
          id,
          title: name,
          type: 'item',
          url: `/campaign/${id}`,
          breadcrumbs: false,
        };
      }),
  ];

  if (campaignItems.length > 4) {
    pendingCampaigns.push({
      id: 'outline-chip-menu',
      title: 'SHOW ALL',
      type: 'item',
      url: '/',
      button: {
        variant: 'outlined',
        color: 'primary',
      },
    });
  }

  const activeCampaigns = [];
  const completedCampaigns = [];
  // const activeCampaigns = campaignItems
  //   .filter((el) => el.status !== campaignStatuses.CAMPAIGN_CREATED)
  //   .map(({ id, name }) => {
  //     return { id, title: name, type: 'item', url: `/campaign/${id}`, breadcrumbs: false };
  //   });
  // const completedCampaigns = campaignItems
  //   .filter((el) => el.status === campaignStatuses.PRODUCTION_IN_PROGRESS)
  //   .map(({ id, name }) => {
  //     return { id, title: name, type: 'item', url: `/campaign/${id}`, breadcrumbs: false };
  //   });

  return {
    id: 'campaigns',
    title: 'Campaigns',
    type: 'group',
    children: [
      {
        id: 'wellness-kiosks',
        title: 'Wellness Billboards',
        type: 'collapse',
        icon: icons.IconDeviceAnalytics,
        children: [
          {
            id: 'pending',
            title: 'Pending',
            type: 'collapse',
            children: pendingCampaigns,
          },
          {
            id: 'active',
            title: 'Active',
            type: 'collapse',
            children: activeCampaigns,
          },
          {
            id: 'completed',
            title: 'Completed',
            type: 'collapse',
            children: completedCampaigns,
          },
        ],
      },
      // {
      //   id: 'digital-ads',
      //   title: 'Digital Ads',
      //   type: 'item',
      //   icon: icons.IconDashboard,
      //   url: '#',
      //   breadcrumbs: false,
      // },
      // {
      //   id: 'messages',
      //   title: 'Messages',
      //   type: 'item',
      //   icon: icons.IconMessages,
      //   url: '/chat',
      //   breadcrumbs: false,
      //   chip: {
      //     label: '3',
      //     color: 'secondary',
      //   },
      // },
      // {
      //   id: 'payments',
      //   title: 'Payments',
      //   type: 'item',
      //   icon: IconWallet,
      //   url: '/payments',
      //   breadcrumbs: false,
      // },
    ],
  };
};

export default campaigns;
